import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cmp-drag-file',
  template: `<div class="drop-box p-3">
  <div class="drop-content">
    <div class="drop-info mt-5 mb-5">
      <i class="fa fa-arrow-circle-o-down fa-3x text-center d-block text-primary mb-3" aria-hidden="true"></i>
      <h4 class="text-center text-primary align-middle">Drag a chart it here!</h4>
    </div>
  </div>
</div>
`,
  styles: [``]
})
export class DragFileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
